import {getLanguage, i18n} from 'src/i18n';
import {Label} from '../api/types/types';

const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE ?? 'sv';
let supportedLanguages = process.env.REACT_APP_SUPPORTED_LANGUAGES ?? '';
const supportedLanguagesList = supportedLanguages ? supportedLanguages.split(',') : [];

type CountryCode = 'en' | 'fi' | 'sv';
type RegionCode = 'en-gb' | 'fi-fi' | 'sv-se';
type LocationMap = {
    sv?: string;
    en?: string;
    fi?: string;
};

const systemLocale = process.env.REACT_APP_SYSTEM_COUNTRY ?? 'sv';

export function getSystemCountry(): CountryCode {
    return systemLocale as CountryCode;
}

export function setLocale(locale: string) {
    if (supportedLanguagesList.includes(locale) === false) {
        throw new Error(`Unsupported language: ${locale}`);
    }
    i18n.changeLanguage(locale);
}

export function getLocale(): CountryCode {
    return getLanguage() as CountryCode;
}

export function getLocaleWithRegionCode(): RegionCode {
    return getLocaleWithRegionFromLang(getLocale());
}

export function getLocaleWithRegionFromLang(lang: string): RegionCode {
    const localeMap: LocationMap = {
        sv: 'sv-se',
        en: 'en-gb',
        fi: 'fi-fi'
    };

    let location = localeMap[lang as keyof LocationMap];
    if (location === undefined) {
        location = localeMap[defaultLanguage as keyof LocationMap];
    }

    return location as RegionCode;
}

export function getTextFromLocale(listOfTerms: Array<Label> | undefined, targetLanguageLocale = ''): string {
    if (targetLanguageLocale === '') {
        targetLanguageLocale = getLocaleWithRegionCode();
    }
    return listOfTerms?.find(({locale}) => targetLanguageLocale === locale)?.text ?? '';
}
